import {formatDate} from "@ui-seeker/utils";


export default function dateColumn() {
	return {
		name: 'date', label: 'Date',
		options: {
			customBodyRowRender: value => formatDate(value, { isString: true })
		}
	}
}